import {CommonResponse, GetParamsType, GetSingleParamsType, instance} from "./API"
import {AxiosResponse} from "axios"
import {filterToString} from "../helps/filterToString"
import {CompaniesResponse, CompanyResponse} from "../models/response"

export const psLeakDeviceLogApi = {
    getLogs(params?: GetParamsType & PSLeakDeviceLogsFilterQuery): Promise<CommonResponse<CompaniesResponse>> {
        const paramsString = filterToString(params)
        return instance.get(`PSLeakDeviceLog${paramsString}`, {signal: params?.controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    getLog(params: GetSingleParamsType): Promise<CommonResponse<CompanyResponse>> {
        const {id, controller} = params
        return instance.get(`PSLeakDeviceLog/${id}`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
}

export type PSLeakDeviceLogsFilterQuery = {
    idCompany?: number
    idObjectGroup?: number
    idObject?: number
    idDevice?: number
    dateFrom?: string | null | undefined
    dateTo?: string | null | undefined
    search?: string
}